import { Alert, Box, Button, CircularProgress, Stack } from "@mui/material";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchOssDashboard } from "../../api/ossApi";
import { OssPageHeader } from "../../components/common/OssPageHeader";
import { OssDashboardKpiBoard } from "../../components/dashboard/OssDashboardKpiBoard";
import { OssDashboardTimelinePanel } from "../../components/dashboard/OssDashboardTimelinePanel";
import {
  initialDashboardData,
  isEmptyDashboard,
  kpiConfig,
} from "../../components/dashboard/dashboardConfig";
import { mockDashboard } from "../../constants/mockData";
import { useOssAsyncData } from "../../hooks/useOssAsyncData";

export const OssDashboard = () => {
  const { group_code, project_code } = useParams();
  const navigate = useNavigate();
  const { data, loading, error, load } = useOssAsyncData({
    fetcher: () => fetchOssDashboard(group_code, project_code),
    fallbackData: initialDashboardData,
    errorMessage: "운영 현황을 불러오지 못했습니다.",
    deps: [group_code, project_code],
  });

  const viewData = isEmptyDashboard(data) ? mockDashboard : data;
  const kpiItems = useMemo(
    () =>
      kpiConfig.map((item) => ({
        ...item,
        value: viewData.summary[item.key] || 0,
      })),
    [viewData.summary]
  );

  if (loading) {
    return (
      <Box sx={{ minHeight: 420, display: "grid", placeItems: "center" }}>
        <CircularProgress size={34} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: { xs: "auto", lg: "100%" },
        minHeight: 0,
        bgcolor: "#f3f6fa",
        overflow: { xs: "auto", lg: "hidden" },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Stack spacing={{ xs: 2.5, lg: 1.65 }} sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        <OssPageHeader
          title="주문일정관리 현황"
          iconName="homeIcon"
        />

        {error && (
          <Alert severity="error" action={<Button color="inherit" onClick={load}>재시도</Button>}>
            {error}
          </Alert>
        )}

        <OssDashboardKpiBoard items={kpiItems} />

        <Box sx={{ flex: 1, minHeight: 0, height: "100%", maxHeight: "100%", display: "flex", overflow: "hidden" }}>
          <OssDashboardTimelinePanel onOpenOrder={(orderId) => navigate(`orders?selectedOrderId=${orderId}`)} />
        </Box>
      </Stack>
    </Box>
  );
};
